import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { OutstandingBalancesReport } from "@/pages/auswertungen/OutstandingBalancesReport";

export function OutstandingBalancesPage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["outstanding-balances"]}
    >
      <OutstandingBalancesReport />
    </AppShell>
  );
}
